/* eslint-disable */
const timeoutLimit = 800; // delka timeoutu
let queue = []; //fronta na zmackle klavesy
let map = {}; // seznam navesenych mapovani a jejich callbacku
let timeout = null; // timeout na zmacknuti dane kombinace, pokud prijde dalsi klavesa nulujeme a nic nespustime

export function addMap(mapString: string = "", cb: void) {
	map[mapString] = cb;
}

export function removeMap(mapString: string = "") {
	mapString != "" && map[mapString] && delete map[mapString];
}

function keyDown(e: KeyboardEvent) {
	queue.push(e.keyCode);
	const str = queue.join(",");
	let maxlen = 0;
	window.clearTimeout(timeout);
	timeout = null;

	for (var p in map) {
		maxlen = Math.max(maxlen, p.length);
		if (str.indexOf(p) > -1) {
			timeout = window.setTimeout(function() {
				queue = [];
				timeout = null;
				map[p]();
			}, timeoutLimit);
			break;
		}
	}

	if (str.length > maxlen) { queue.shift(); }
}

addEventListener("keydown", keyDown);
